import { Command } from 'commands/Commands';

export class RequestApproval extends Command {
  type: string = 'Page.RequestApproval';
  priority: number = 150;
}

export class Approve extends Command {
  type: string = 'Page.Approve';
  priority: number = 150;
}

export class Reject extends Command {
  type: string = 'Page.Reject';
  priority: number = 150;
}
